import {
  pasos as pasosComunes,
  premios as premiosCGU,
  beneficios as beneficiosCGU
} from "@/config/brands/ofertaCommon";

const legales_cgu = `CARTERA DE CONSUMO. Mantenimiento Mensual: $0. (*) Para más información consulta en <a href="https://www.bbva.com.ar/personas/productos/cuentas/gratuita-universal.html" target="_blank">https://www.bbva.com.ar/personas/productos/cuentas/gratuita-universal.html</a> <br />
    AVISO LEGAL "Los depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta $ 1.500.000. En las
    operaciones a nombre de dos o más personas, la garantía se prorrateará entre sus titulares. En ningún caso, el total de la
    garantía por persona y por depósito podrá exceder de $ 1.500.000, cualquiera sea el número de cuentas y/o depósitos. Ley
    24485, Decreto 540/1995 y modificatorios y Com. "A" 2337 y sus modificatorias y complementarias. Se encuentran excluidos
    los captados a tasas superiores a la de referencia conforme a los límites establecidos por el Banco Central, los adquiridos por
    endoso y los efectuados por personas vinculadas a la entidad financiera."<br />
    Los accionistas de BANCO BBVA ARGENTINA S.A. limitan su responsabilidad a la integración de las
    acciones suscriptas a la ley 19.550 y ley 25.738. CUIT 30-50000319-3. Av. Córdoba 111, piso 31, CABA -
    CP 1054.
`;

/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleAnalyticsId: null,
  googleGTMId: null,
  modulo: "Cuenta Gratuita Universal y Tarjeta de Débito",
  cantPasos: 9,
  pasos: {
    ...pasosComunes,
    consulta: {
      component: "views/ConsultaCA",
      titulo: "Abrí tu primera cuenta en BBVA",
      subtitulo:
        "Te pedimos estos datos para poder abrir tu Cuenta Gratuita Universal y tu Tarjeta de Débito"
    },
    ofertaCuenta: {
      path: "/ofertaCuenta",
      component: "views/OfertaCuenta",
      titulo: "Cuenta Gratuita Universal + Visa Débito",
      subtitulo: "Tené tu primera cuenta en BBVA y disfrutá de:",
      botonSiguiente: "Abrí tu cuenta en BBVA",
      footerText: legales_cgu
    },
    gracias: {
      pasoAnterior: "sucursal"
    }
  }
};

export const oferta = [
  "<strong>Cuenta Gratuita Universal</strong><br>",
  "<strong>Tarjeta Visa Débito</strong>"
];

export const proximosPasos = [
  {
    buttonLabel: "Solicitar turno",
    buttonLink: "https://apps.bbva.com.ar/openmarket/turnos/personas/#/",
    detail:
      "En la sucursal además te pediremos un domicilio para enviarte por correo la tarjeta de débito. No hace falta que la recibas vos, ya que cualquier persona mayor de 14 años podrá hacerlo.",
    label:
      "<strong>Solicitá un turno online</strong> para acercarte a la sucursal que elegiste para firmar el contrato de tu cuenta."
  },
  {
    label:
      "<strong>Ingresá a banca online.</strong> Cuando recibas tu tarjeta de débito, ingresá a banca online y creá tu Usuario y Clave digital.",
    modal: "Cómo obtener mi Usuario y Clave Digital"
  },
  {
    cbu: true,
    label:
      "Te damos tu número de CBU para que ya lo tengas a mano, pero recordá que para empezar a operar tendrás que hacer primero los pasos anteriores"
  }
];

export const premios = [...premiosCGU];

export const beneficios = [...beneficiosCGU];
